import React from "react";
import { ReactComponent as UploadIcon } from "../../../../assets/upload.svg";

const ClickUpload = ({ fileAccepts = "PDF", fileLimit = 30 }) => {
  return (
    <div
      className="custom-drag__upload-area"
      style={{ paddingRight: 0, paddingLeft: 0 }}
    >
      <div
        className="flex-column align-items-center"
      >
        <UploadIcon style={{ marginTop: "0.625rem" }} />
        <div
          className="d-flex align-items-center click-upload"
          style={{ width: "100%", marginTop: "0.625rem", marginBottom: "0.375rem" }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>
            <span
              id="click-to-upload"
              style={{ color: "#725798", fontWeight: "bold" }}
            >
              Click to upload
            </span>
            <span id="or-drag-and-drop">&nbsp;or drag and drop</span>
          </div>
          {/* <div style={{ width: "100%", textAlign: "left" }}>
            &nbsp;or drag and drop
          </div> */}
        </div>
        <div
          className="d-flex file-specs"
          style={{ width: "100%", marginBottom: "0.625rem" }}
        >
          <div>
            {fileAccepts} &nbsp;(max file size: {fileLimit}MB)
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClickUpload;
